import React from 'react'

const CompanyIcon: React.FC = () => (
	<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
		<path
			className="fill-current"
			fillRule="evenodd"
			d="M20.905 22.594h2.392a.703.703 0 110 1.406H.703a.703.703 0 110-1.406h2.402V10.703c0-.893.492-1.702 1.285-2.112l5.974-3.09v-1.4l-.746-.307a.703.703 0 11.534-1.3l.212.086v-.92l-.746-.306a.703.703 0 01.534-1.301L22.167 4.99a.703.703 0 11-.534 1.301l-.728-.3v.92l1.262.52a.703.703 0 01-.534 1.3l-.728-.299v14.16zm-1.407-17.18l-7.727-3.176v.92l7.727 3.177v-.92zM8.141 22.595v-2.237a.703.703 0 00-1.406 0v2.237H4.51v-4.352h2.927a.703.703 0 000-1.406H4.51v-1.175h2.927a.703.703 0 100-1.406H4.51v-1.212h2.927a.703.703 0 100-1.406H4.51v-.934c0-.365.201-.695.525-.863l5.328-2.756v15.51H8.141zm9.603-2.237v2.237h1.754V7.855L11.771 4.68v17.915h1.754v-2.237a.703.703 0 011.406 0v2.237h1.407v-2.237a.703.703 0 011.406 0z"
			clipRule="evenodd"
		/>
	</svg>
)

export default CompanyIcon
